module.exports = __webpack_public_path__ + "static/img/Shane.Charter.e261ee9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Shane.Charter.jpg
// module id = Df7U
// module chunks = 0